import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  private pageTitle$ = new BehaviorSubject<string>("");
  private title = inject(Title);

  setTitle(tit: string): void {
    this.pageTitle$.next(tit);
    this.title.setTitle(environment.pageTitlePrefix + " - " + tit);
  }

  getTitle(): Observable<string> {
    return this.pageTitle$.asObservable();
  }
}
